<app-multiline-text #textAreaField [autoFocus]="true" rows="{{numberRows}}" [maxlength]="maxlength" placeholder="{{placeholder}}" [(value)]="tekst">
</app-multiline-text>
